import { render, staticRenderFns } from "./UpdateDetailsSvg.vue?vue&type=template&id=24a6578d&scoped=true&"
var script = {}
import style0 from "./UpdateDetailsSvg.vue?vue&type=style&index=0&id=24a6578d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6578d",
  null
  
)

export default component.exports